import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';

@Component({
  selector: 'app-mb-empty-list',
  imports: [CommonModule],
  templateUrl: './mb-empty-list.component.html',
  standalone: true,
})
export class MbEmptyListComponent {
  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;
}
